import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import cn from 'classnames';

import ConfigContext from '../../../contexts/ConfigContext';

// Components
import Meta from '../../shared/Meta';
import CostEstimator from '../content/CostEstimator';
import FeaturedTrucks from '../FeaturedTrucks';
import CtaImage from '../content/CtaImage';
import LogoList from '../content/LogoList';
import AnyEvent from '../content/AnyEvent';
import FeaturedCuisines from '../FeaturedCuisines';
import CateringCta from '../content/CateringCta';
import HowItWorks from '../content/HowItWorks';
import WhyBookWithUs from '../content/WhyBookWithUs';
import Testimonials from '../content/Testimonials';
import CateringFaq from '../faqs/CateringFaq';

import styles from '../../../../stylesheets/public/layouts/AboutPage.module.postcss';

const featuredTrucks = { featured: true };

function BirthdayPartyCatering() {
  const { vehicle_type, city_name, site_title } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  return (
    <div className='CateringPage'>
      <Meta
        title={`Birthday Party Food ${vehicle_type} Catering`}
        type='website'
        canonical='/food-truck-catering/birthday-parties'
        image='https://static.seattlefoodtruck.com/photos/community.webp'
        description={`Book a food ${vehicleType} for your birthday party in ${city_name}. Kids' parties to milestone celebrations. Get free quotes from ${city_name}'s best food ${vehicleType}s.`}
        structuredData={{
          cateringService: {
            name: `Birthday Party Food ${vehicle_type} Catering in ${city_name}`,
            description: `Book a food ${vehicleType} for your birthday party in ${city_name}. Kids' parties to milestone celebrations.`,
            url: '/food-truck-catering/birthday-parties',
            serviceType: 'Birthday Party Food Truck Catering',
          },
          breadcrumbs: {
            listItems: [
              { '@type': 'ListItem', position: 2, name: 'Catering', item: '/catering' },
              { '@type': 'ListItem', position: 3, name: 'Birthday Party Catering', item: '/food-truck-catering/birthday-parties' }
            ]
          }
        }}
      />

      <div className='Section'>
        <div className={cn(styles.Cta, styles.Cta__reversed)}>
          <CtaImage image='https://static.seattlefoodtruck.com/photos/community.webp' noLazy isResponsive />
          <div className={styles.Cta_copy}>
            <h1>Book a Food {vehicle_type} for Your Birthday Party</h1>
            <p>Make your next birthday party one to remember! Skip the usual catering and surprise your guests with a food {vehicleType} serving fresh, made-to-order meals. Whether it&#39;s a kids&#39; party, a milestone celebration, or a <Link to='/food-truck-catering/private-parties'>backyard bash</Link>, {city_name}&#39;s food {vehicleType}s bring the fun, the flavor, and the wow factor. {site_title} makes it easy to browse, <Link to='/food-truck-catering/prices'>compare prices</Link>, and book the perfect {vehicleType} for your party.</p>
            <p>
              <Link to='/catering/register' className='Button Button--mobile-w100'>Plan Your Birthday Party</Link>
            </p>
          </div>
        </div>
      </div>

      <section className='Section'>
        <LogoList title='Trusted by leading companies' titleClassName='u-textCenter' className='u-mt1' />
      </section>

      <FeaturedTrucks title={`Popular Food ${vehicle_type}s for Parties`} options={featuredTrucks} />

      <WhyBookWithUs title={`Why Book a Food ${vehicle_type} for a Birthday Party?`} />

      <section className='Section--extraPadding'>
        <h2 className='u-textCenter u-mb3'>The Perfect Party for Every Age</h2>
        <div className={cn(styles.Cta, styles.Cta__reversed)}>
          <CtaImage image='https://static.seattlefoodtruck.com/photos/catering5.webp' isResponsive />
          <div className={styles.Cta_copy}>
            <h3>Kids&#39; Birthday Parties</h3>
            <p>Food {vehicleType}s are a huge hit with kids! From ice cream and churros to mac and cheese and sliders, there&#39;s something for every young foodie. The interactive experience of ordering from a {vehicleType} makes the party feel like a special event, and parents love the convenience of having everything served fresh without the cleanup hassle.</p>
          </div>
        </div>
      </section>

      <section className='Section'>
        <div className={styles.Cta}>
          <CtaImage image='https://static.seattlefoodtruck.com/photos/catering4.webp' isResponsive />
          <div className={styles.Cta_copy}>
            <h3>Adult & Milestone Celebrations</h3>
            <p>Celebrating a 30th, 40th, 50th, or beyond? A food {vehicleType} adds a unique, memorable touch. Choose a gourmet {vehicleType} for an elevated experience, or go with a fun theme like tacos, BBQ, or fusion cuisine. Many {vehicleType}s offer drink pairings and dessert options to round out the celebration.</p>
          </div>
        </div>
      </section>

      <HowItWorks />

      <AnyEvent />

      <Testimonials title="See what our customers are saying" />

      <CostEstimator />

      <section className='Section--extraPadding'>
        <FeaturedCuisines />
      </section>

      <section className='Section--extraPadding'>
        <CateringFaq />
      </section>

      <section className='Section--extraPadding'>
        <CateringCta title={`Book a Food ${vehicle_type} for Your Birthday Party!`} />
      </section>
    </div>
  );
}

export default BirthdayPartyCatering;
